import React, { useEffect, useState, useRef } from 'react';
import {
  Table,
  Pagination,
  Modal,
  Tabs,
  Button,
  Space,
  Typography,
  Image,
  Input,
  message,
  Select,
  Tag,
  Descriptions,
  Row,
  Col,
  Message,
} from 'antd';
import QRCode from 'qrcode.react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { PlayCircleOutlined } from '@ant-design/icons';
import ProTable from '@ant-design/pro-table';

import styles from './index.less';
import Xgplayer from 'xgplayer-react';
import {
  getUserClass,
  getClassDetail,
  commentClassAction,
} from '@/services/athena';
import {
  getCancelInfo,
  getAttendStatus,
  queryCategories,
  getClassRoom,
  getCompleteClassInfoForPalmer,
  roomCtl,
  queryClassLiveLink,
  shield,
  unblock,
  getCourseAttendRecord,
  queryClassDetailContent,
  getCompleteActionDetailGptResponse,
  remarkDetailByRoomId,
  classEventRecord,
} from '@/services/operating';
import moment from 'moment';
import { formatTime } from '@/utils/utils';

import ClassActionView from '@/components/ClassActionView';
import CourseInfoView from '@/components/CourseInfoView';
import ModalVideo from '@/components/ModalVideoXg';

const { TabPane } = Tabs;
const { Title, Paragraph } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const Curriculum = (props) => {
  const { tenantId } = props;
  const actionRef = useRef();
  const detailRef = useRef();

  // 详情弹窗相关状态
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
  const [detailRecord, setDetailRecord] = useState(null);

  const [commentData, setCommentData] = useState(null);
  const [remarkDetailData, setRemarkDetailData] = useState(null);
  const [classCommentRecord, setClassCommentRecord] = useState(null);
  const [classCommentInfoList, setClassCommentInfoList] = useState([]);
  const [completeClassInfo, setCompleteClassInfo] = useState(null);
  const [completeClassCommentInfo, setCompleteClassCommentInfo] =
    useState(null);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryInput, setSummaryInput] = useState('');
  const [activeTab, setActiveTab] = useState('1');

  // 课程类别相关状态
  const [classRoomCategoryList, setClassRoomCategoryList] = useState([]);
  const [userAttend, setUserAttend] = useState();
  const [coachAttend, setCoachAttend] = useState();
  const [classList, setClassList] = useState([]);

  // 取消原因相关状态
  const [isReasonModalVisible, setIsReasonModalVisible] = useState(false);
  const [reasonRecord, setReasonRecord] = useState(null);

  // 巡课相关状态
  const [isPatrolModalVisible, setIsPatrolModalVisible] = useState(false);
  const [inputQRUrl, setInputQRUrl] = useState('');
  const [inputH5Url, setInputH5Url] = useState('');
  const [inputLiveUrl, setInputLiveUrl] = useState('');

  // 直播播放相关状态
  const [liveVideoPlayVisible, setLiveVideoPlayVisible] = useState(false);
  const [liveVideoPlaySrc, setLiveVideoPlaySrc] = useState('');

  // 回看相关状态
  const [state, setState] = useState({
    visible: false,
    replaceVideoVisible: false,
    videoPlayVisible: false,
    createModalVisible: false,
    confirmLoading: false,
  });
  const [xgConfig, setXgConfig] = useState({});
  const [xgPlayer, setXgPlayer] = useState();
  const [currentRoomid, setcurrentRoomid] = useState(undefined);
  const [record, setrecord] = useState([]);
  const [isBeginPlay, setBeginPlay] = useState(false);

  // 获取课程类别名称的辅助函数
  const getCategoryName = (category) => {
    let categoryName = '';
    classRoomCategoryList.forEach((e) => {
      if (e.category == category) {
        categoryName = e.categoryName;
      }
    });
    return categoryName;
  };

  // 初始化课程类别数据
  useEffect(() => {
    queryCategories({}).then(({ data, code, msg }) => {
      if (code == '00000') {
        setClassRoomCategoryList(data);
      } else {
        message.error(msg);
      }
    });
  }, []);

  // 详情弹窗事件处理函数
  const handleDetailModalCancel = () => {
    setIsDetailModalVisible(false);
    setDetailRecord(null);
    setActiveTab('1');
  };

  const detail = async (record) => {
    setDetailRecord(record);
    setIsDetailModalVisible(true);

    // 获取课程详情数据
    try {
      // 获取出勤记录
      const attendRes = await getAttendStatus({
        requestData: { roomNo: record.roomNo, courseId: record.courseId },
      });
      if (attendRes.code === '00000') {
        setUserAttend(attendRes?.data?.userAttendStatus);
        setCoachAttend(attendRes?.data?.coachAttendStatus);
      }

      // 获取上课内容
      const detailRes = await queryClassDetailContent({
        requestData: {
          roomNo: record.roomNo,
          courseId: record.courseId || '0',
        },
      });
      if (detailRes.code === '00000') {
        setClassList(detailRes?.data || []);
      }

      // 获取教练评语
      const commentRes = await getClassRoom({
        requestData: { roomId: record.roomId },
      });
      if (commentRes.code === '00000') {
        setCommentData(commentRes?.data || {});
      }

      // 获取完课信息
      const completeRes = await getCompleteClassInfoForPalmer({
        requestData: { roomId: record.roomId, userId: record.userId },
      });
      if (completeRes.code === '00000') {
        setCompleteClassInfo(completeRes?.data || {});
      }

      // 获取完课评语详情（包含视频和精彩瞬间）
      const completeCommentRes = await getCompleteActionDetailGptResponse({
        requestData: { roomId: record.roomId, userId: record.userId },
      });
      if (completeCommentRes.code === '00000') {
        setCompleteClassCommentInfo(completeCommentRes.data || {});
      }
      remarkDetailByRoomId({
        requestData: {
          roomId: record.roomId,
        },
      }).then(({ code, msg, data }) => {
        if (code === '00000') {
          setClassCommentRecord(data?.commentOrderInformation || {});
          setClassCommentInfoList(data?.remarkDetailInformationList || []);
          setRemarkDetailData(data || {});
        } else {
          setClassCommentRecord(null);
          setClassCommentInfoList([]);
          setRemarkDetailData({});
          message.error(msg);
        }
      });
    } catch (error) {
      console.error('获取课程详情失败:', error);
      message.error('获取课程详情失败');
    }
  };

  // 查看取消原因
  const viewCancelReason = (record) => {
    getCancelInfo({
      requestData: {
        roomId: record.roomId,
      },
    }).then(({ data, code, msg }) => {
      if (code === '00000') {
        setReasonRecord(data);
      } else {
        message.error(msg);
      }
    });
    setIsReasonModalVisible(true);
  };

  // 关闭取消原因弹窗
  const handleReasonCancel = () => {
    setReasonRecord(null);
    setIsReasonModalVisible(false);
  };

  const handleSummarySend = () => {
    if (!summaryInput.trim()) {
      message.warning('请输入内容');
      return;
    }
    setSummaryLoading(true);
    // 这里可以添加发送逻辑
    setTimeout(() => {
      setSummaryLoading(false);
      setSummaryInput('');
      message.success('发送成功');
    }, 1000);
  };

  const goPreview = (url) => {
    if (!url || typeof url !== 'string') {
      return;
    }
    setLiveVideoPlaySrc(url);
    setLiveVideoPlayVisible(true);
  };

  // 回看视频
  const playback = (playbackUrl, record) => {
    setrecord([]);
    setState({
      videoPlayVisible: true,
    });
    setXgConfig({
      id: 'mse',
      url: playbackUrl,
      autoplay: true,
      playbackRate: [1.0, 2.0, 3.0],
      screenShot: true,
      playsinline: true,
      cssFullscreen: true, // 网页样式全屏
      fluid: true,
      enableContextmenu: true, // 右键菜单
      progressDot: [],
    });
    setcurrentRoomid(record.roomId);
  };

  const hideVideoPlay = () => {
    setState({ videoPlayVisible: false });
    setXgConfig({
      url: '',
    });
    xgPlayer.destroy(false);
  };

  const columnsMark = [
    {
      title: '时间',
      dataIndex: 'eventTime',
      render: (text) => {
        return formatTime(text / 1000);
      },
    },
    {
      title: '事件类型',
      dataIndex: 'eventType',
      valueEnum: {
        1: { text: '安全确认' },
        2: { text: '点赞' },
        3: { text: '记录' },
      },
    },
    {
      title: '对应动作',
      dataIndex: 'actionName',
    },
    {
      title: '完成情况',
      dataIndex: 'completeStatus',
    },
    {
      title: '截图',
      dataIndex: 'highlightImg',
      render: (text) => {
        return text !== '-' ? <Image width={100} src={text} /> : '--';
      },
    },
  ];

  // 强制关流
  const forceClose = (record) => {
    // 3 关闭
    roomCtrl(record, 3);
  };

  // 房间操作
  const roomCtrl = async (record, option) => {
    const params = {
      roomId: record.roomId,
      option: option,
      record: false,
    };
    const { code, msg } = await roomCtl({
      requestData: {
        ...params,
      },
    });
    if (code === '00000') {
      Message.success('操作成功！');
    } else {
      Message.error(msg);
    }
  };

  // 巡课
  const patrol = (record) => {
    queryClassLiveLink({
      requestData: {
        roomId: record.roomId,
      },
    }).then(({ data, code, msg }) => {
      if (code === '00000') {
        setInputQRUrl(data?.maLink || '');
        setInputH5Url(data?.h5Link || '');
        setInputLiveUrl(data?.liveUrl || '');
        setIsPatrolModalVisible(true);
      } else {
        Message.error(msg);
      }
    });
  };

  // 关闭巡课弹窗
  const handlePatrolModalCancel = () => {
    setIsPatrolModalVisible(false);
    setInputQRUrl('');
    setInputH5Url('');
    setInputLiveUrl('');
  };

  // 二维码输入变化
  const qrCodeInputChange = (e) => {
    setInputH5Url(e.target.value);
  };

  // 播放直播
  const playLive = (url) => {
    setIsPatrolModalVisible(false);
    if (!url) return;
    setLiveVideoPlaySrc(url);
    setLiveVideoPlayVisible(true);
  };

  // 释放回看
  const releasePlayback = (record) => {
    unblock({
      requestData: {
        roomId: record.roomId,
      },
    }).then(({ code, msg }) => {
      if (code === '00000') {
        Message.success('释放回看成功');
        actionRef.current?.reload();
      } else {
        Message.error(msg);
      }
    });
  };

  // 拦截回看
  const blockPlayback = (record) => {
    shield({
      requestData: {
        roomId: record.roomId,
      },
    }).then(({ code, msg }) => {
      if (code === '00000') {
        Message.success('拦截回看成功');
        actionRef.current?.reload();
      } else {
        Message.error(msg);
      }
    });
  };

  const columns = [
    {
      title: '课表ID',
      key: 'roomId',
      dataIndex: 'roomId',
    },
    {
      title: '上课时间',
      key: 'startTime',
      dataIndex: 'startTime',
    },
    {
      title: ' 创建时间',
      key: 'ctime',
      dataIndex: 'ctime',
    },
    {
      title: '课程名称',
      key: 'title',
      dataIndex: 'title',
    },
    {
      title: '预约方式',
      key: 'appointTypeName',
      dataIndex: 'appointTypeName',
    },
    {
      title: '用户账号',
      key: 'wxNickName',
      dataIndex: 'wxNickName',
      render: (text, record) => {
        if (!record.userId) {
          return text;
        }
        return (
          <a
            href={`/user/record?id=${record.userId}&phone=${record.userPhone}`}
            target="_blank"
            rel="noreferrer"
          >
            {text}
          </a>
        );
      },
    },
    {
      title: '上课老师',
      key: 'coachName',
      dataIndex: 'coachName',
    },
    {
      title: '课程类别',
      key: 'categoryName',
      dataIndex: 'categoryName',
      render: (value) => <Tag>{value}</Tag>,
    },
    {
      title: '训练方式',
      key: 'trainingMannerDesc',
      dataIndex: 'trainingMannerDesc',
      render: (_, record) => {
        const { trainingMannerDesc, classInTrainingMethodsDesc } = record;
        return (
          <Space size={1}>
            <Tag>{trainingMannerDesc}</Tag>
            {classInTrainingMethodsDesc && (
              <Tag color={'green'}>{classInTrainingMethodsDesc}</Tag>
            )}
          </Space>
        );
      },
    },
    {
      title: '课表状态',
      dataIndex: 'status',
      key: 'status',
      render: (text) => {
        const statusMap = {
          1: { text: '待上课', color: 'orange' },
          2: { text: '上课中', color: 'blue' },
          3: { text: '已下课', color: 'green' },
          4: { text: '已完课', color: 'green' },
          5: { text: '未上课', color: 'red' },
          6: { text: '旷课', color: 'red' },
          7: { text: '取消', color: 'gray' },
          8: { text: '待领取', color: 'purple' },
          9: { text: '到课热身', color: 'cyan' },
          10: { text: '到课训练', color: 'lime' },
          11: { text: '到课试练', color: 'lime' },
        };
        const status = statusMap[text] || { text: '未知', color: 'default' };
        return <Tag color={status.color}>{status.text}</Tag>;
      },
    },
    {
      title: '操作',
      key: 'action',
      width: 120,
      render: (text, record) => (
        <Space size="middle">
          {record.status == 7 ? (
            <Button
              type="link"
              size="small"
              onClick={() => viewCancelReason(record)}
            >
              详情
            </Button>
          ) : (
            <Button type="link" size="small" onClick={() => detail(record)}>
              详情
            </Button>
          )}
        </Space>
      ),
    },
  ];

  // 渲染出勤记录表格
  const attendTable = () => {
    const detailColumns = [
      {
        title: '时间',
        dataIndex: 'operateTime',
        key: 'operateTime',
        render: (text, record) => {
          return moment(record.operateTime).format('YYYY-MM-DD HH:mm:ss');
        },
      },
      {
        title: '人员昵称',
        dataIndex: 'personName',
        key: 'personName',
      },
      {
        title: '人员类型',
        dataIndex: 'personType',
        key: 'personType',
        valueEnum: {
          0: { text: '用户' },
          1: { text: '教练' },
          2: { text: '巡课' },
        },
      },
      {
        title: '进出类型',
        dataIndex: 'attendType',
        key: 'attendType',
        valueEnum: {
          0: { text: '进入' },
          1: { text: '离开' },
        },
      },
      {
        title: '上课终端类型',
        dataIndex: 'terminalType',
        key: 'terminalType',
      },
      {
        title: '微信版本号',
        dataIndex: 'wxVersion',
        key: 'wxVersion',
      },
    ];

    return (
      <ProTable
        columns={detailColumns}
        actionRef={detailRef}
        request={async (params) => {
          const { data, page, code } = await getCourseAttendRecord({
            requestData: {
              ...params,
              roomNo: detailRecord.roomNo,
              courseId: detailRecord.courseId,
            },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos2',
          persistenceType: 'localStorage',
        }}
        rowKey={(record) => record.id}
        search={false}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
        toolBarRender={false}
      />
    );
  };

  // 渲染课程内容
  const classContentOP = () => {
    return (
      <div className={styles.minH500}>
        {classList?.map((e) => (
          <div key={e?.phaseId}>
            <Descriptions
              column={{ sm: 1 }}
              title={e?.phaseName}
              size="small"
              bordered
              key="d2"
            >
              {(e?.coursePhaseActionModelList || []).map((item) => (
                <Descriptions.Item
                  className={styles.w400}
                  label={item.actionName}
                  key={item.actionId}
                >
                  <div className={styles.rowBetween}>
                    {item.actionGroup}
                    <span className={styles.w100Center}>
                      {item?.completeStatus ? '已训练' : '/'}
                    </span>
                  </div>
                </Descriptions.Item>
              ))}
            </Descriptions>
            <br />
          </div>
        ))}
      </div>
    );
  };

  // 课程详情描述组件
  const classDetailDescriptions = () => {
    if (!detailRecord) return null;

    return (
      <Descriptions
        column={{ sm: 2 }}
        title="课表信息"
        size="small"
        bordered
        key="d1"
      >
        <Descriptions.Item label="开始时间" key="1">
          {detailRecord?.startTime}
        </Descriptions.Item>
        <Descriptions.Item label="上课状态" key="2">
          {detailRecord?.statusName}
        </Descriptions.Item>
        <Descriptions.Item label="上课课节" key="3">
          {detailRecord?.title}
        </Descriptions.Item>
        <Descriptions.Item label="创建时间" key="4">
          {detailRecord?.ctime}
        </Descriptions.Item>
        <Descriptions.Item label="用户账号" key="5">
          {detailRecord?.userName + '(' + detailRecord?.userPhone + ')'}
        </Descriptions.Item>
        <Descriptions.Item label="用户考勤" key="6">
          {userAttend}
        </Descriptions.Item>
        <Descriptions.Item label="上课教练" key="7">
          {detailRecord?.coachName}
        </Descriptions.Item>
        <Descriptions.Item label="教练考勤" key="8">
          {detailRecord?.category === 2 ? '--' : coachAttend}
        </Descriptions.Item>
        <Descriptions.Item label="训练方式" key="9">
          {detailRecord?.trainingMannerDesc}
        </Descriptions.Item>
        <Descriptions.Item label="课程类别" key="10">
          <Tag color={'orange'}>{getCategoryName(detailRecord?.category)}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="课程类型" key="11">
          {detailRecord?.classTypeName}
        </Descriptions.Item>
      </Descriptions>
    );
  };

  // 渲染教练评语
  const classListItemView = () => {
    if (!commentData) {
      return <div>暂无教练评语</div>;
    }

    return (
      <div>
        <Paragraph>
          <blockquote className={styles.quoteBlock}>纬度评分</blockquote>
        </Paragraph>
        <Descriptions>
          <Descriptions.Item label="上肢灵活性">
            {commentData?.fitnessScoreModel?.flexibleUpperlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="下肢灵活性">
            {commentData?.fitnessScoreModel?.flexibleLowerlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="上肢力量">
            {commentData?.fitnessScoreModel?.powerUpperlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="下肢力量">
            {commentData?.fitnessScoreModel?.powerLowerlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="胸椎灵活性">
            {commentData?.fitnessScoreModel?.flexibleThoracic ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="躯干稳定性">
            {commentData?.fitnessScoreModel?.stableTrunk ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="上肢稳定性">
            {commentData?.fitnessScoreModel?.stableUpperlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="下肢稳定性">
            {commentData?.fitnessScoreModel?.stableLowerlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="心肺功能">
            {commentData?.fitnessScoreModel?.heartLung ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="认知协调">
            {commentData?.fitnessScoreModel?.coordinate ?? '-'}
          </Descriptions.Item>
        </Descriptions>

        <Paragraph>
          <blockquote className={styles.quoteBlock}>上课照片</blockquote>
        </Paragraph>
        {commentData?.highlightResponseList?.length > 0 ? (
          <Row gutter={[8, 8]}>
            {commentData?.highlightResponseList?.map((e) => {
              return (
                <Col span={4} key={e?.highlightImg}>
                  <Image
                    width={160}
                    key={e?.highlightImg}
                    src={e?.highlightImg}
                  />
                </Col>
              );
            })}
          </Row>
        ) : (
          '暂无'
        )}

        <Paragraph>
          <blockquote className={styles.quoteBlock}>教练评语</blockquote>
          <pre>{commentData?.coachComment ?? '-'}</pre>
        </Paragraph>
      </div>
    );
  };

  // 取消原因弹窗
  const cancelReasonModal = () => {
    return (
      <Modal
        title="取消原因"
        width={600}
        visible={isReasonModalVisible}
        onCancel={handleReasonCancel}
        footer={null}
        destroyOnClose
      >
        <Descriptions>
          <Descriptions.Item label="操作人" span={3}>
            {reasonRecord?.optName}
          </Descriptions.Item>
          <Descriptions.Item label="操作方式" span={3}>
            {reasonRecord?.channelName}
          </Descriptions.Item>
          <Descriptions.Item label="操作时间" span={3}>
            {reasonRecord?.ctime}
          </Descriptions.Item>
          <Descriptions.Item label="取消原因" span={3}>
            {reasonRecord?.reason}
          </Descriptions.Item>
          <Descriptions.Item label="备注说明" span={3}>
            {reasonRecord?.remark}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    );
  };

  // 详情弹窗
  const detailModal = () => {
    return (
      <Modal
        title="课程详情"
        visible={isDetailModalVisible}
        onCancel={handleDetailModalCancel}
        width={1000}
        destroyOnClose
        footer={[
          <Button key="close" type="primary" onClick={handleDetailModalCancel}>
            关闭
          </Button>,
        ]}
      >
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="考勤记录" key="1">
            <Title level={5}>操作</Title>
            <Space>
              {detailRecord?.status == 4 &&
              detailRecord?.trainingManner !== 2 ? (
                <Button type="primary" onClick={() => forceClose(detailRecord)}>
                  解散房间
                </Button>
              ) : (
                ''
              )}
              {detailRecord?.status == 2 ||
              (detailRecord?.status == 1 &&
                detailRecord?.trainingManner !== 2) ? (
                <Button type="primary" onClick={() => patrol(detailRecord)}>
                  巡课
                </Button>
              ) : (
                ''
              )}
              {detailRecord?.highlightsReady &&
              detailRecord?.highlightsBlocked &&
              detailRecord?.trainingManner !== 2 ? (
                <Button
                  type="primary"
                  onClick={() => releasePlayback(detailRecord)}
                >
                  释放回看
                </Button>
              ) : (
                ''
              )}
              {detailRecord?.highlightsReady &&
              !detailRecord?.highlightsBlocked &&
              detailRecord?.trainingManner !== 2 ? (
                <Button
                  type="primary"
                  onClick={() => blockPlayback(detailRecord)}
                >
                  拦截回看
                </Button>
              ) : (
                ''
              )}
            </Space>
            <br />
            <br />
            {classDetailDescriptions()}
            <br />
            <Title level={5}>出勤记录</Title>
            {attendTable()}
          </TabPane>
          <TabPane tab="上课内容" key="2">
            {classContentOP()}
          </TabPane>
          <TabPane tab="用户视频及点评" key="4">
            <Paragraph>
              <blockquote>视频信息</blockquote>
            </Paragraph>
            {remarkDetailData?.promotionVideoModels &&
            remarkDetailData.promotionVideoModels.length > 0 ? (
              <div className={styles.mbM}>
                {remarkDetailData.promotionVideoModels.map((video, index) => (
                  <div
                    key={index}
                    className={styles.mediaItem}
                    onClick={() => goPreview(video.url || video.videoUrl)}
                  >
                    <Image
                      width={172}
                      height={98}
                      src={
                        video.coverUrl && typeof video.coverUrl === 'string'
                          ? video.coverUrl
                          : ''
                      }
                      className={styles.mediaImg}
                      preview={false}
                    />
                    <div className={styles.playOverlay}>▶</div>
                  </div>
                ))}
              </div>
            ) : detailRecord?.playbackUrl ? (
              <Button
                type="primary"
                onClick={() =>
                  playback(detailRecord?.playbackUrl, detailRecord)
                }
              >
                回看
              </Button>
            ) : (
              '暂无视频'
            )}
            <br />
            <Paragraph>
              <blockquote>回放总结</blockquote>
            </Paragraph>
            <div className={styles.summaryBox}>
              {summaryLoading ? (
                <div className={styles.summaryLoading}>
                  <span className={styles.spinner} />
                  等待总结结果中...
                </div>
              ) : (
                commentData?.playBackSummarize || '暂无回放总结内容'
              )}
            </div>
            {commentData?.vttUrl && (
              <div className={styles.subtitleBox}>
                <span className={styles.subtitleLabel}>字幕文件：</span>
                <a
                  href={commentData.vttUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.subtitleLink}
                >
                  查看字幕文件
                </a>
                <Button
                  type="link"
                  size="small"
                  onClick={() => {
                    navigator.clipboard
                      .writeText(commentData.vttUrl)
                      .then(() => {
                        message.success('链接已复制到剪贴板');
                      })
                      .catch(() => {
                        message.error('复制失败');
                      });
                  }}
                  className={styles.btnTight}
                >
                  复制链接
                </Button>
              </div>
            )}
            {commentData?.playBackSummarize &&
              commentData.playBackSummarize !== '暂无回放总结内容' && (
                <div className={styles.mbM}>
                  <Input.Group compact>
                    <TextArea
                      className={styles.textAreaMain}
                      placeholder="说点什么"
                      value={summaryInput}
                      onChange={(e) => setSummaryInput(e.target.value)}
                      onPressEnter={(e) => {
                        if (!e.shiftKey) {
                          e.preventDefault();
                          handleSummarySend();
                        }
                      }}
                      disabled={summaryLoading}
                      autoSize={{
                        minRows: 1,
                        maxRows: 4,
                      }}
                    />
                    <Button
                      type="primary"
                      loading={summaryLoading}
                      onClick={handleSummarySend}
                      className={styles.btnSide}
                    >
                      发送
                    </Button>
                  </Input.Group>
                </div>
              )}
            <Paragraph>
              <blockquote>精彩瞬间</blockquote>
            </Paragraph>
            <Space size={[16, 16]} wrap>
              {Array.isArray(remarkDetailData?.highlightImages) &&
                remarkDetailData.highlightImages.map((item, index) => {
                  return (
                    <Image
                      key={index}
                      width={'172px'}
                      height={'98px'}
                      className={styles.imgCover}
                      src={item && typeof item === 'string' ? item : ''}
                    />
                  );
                })}
            </Space>
            <ClassActionView
              detailRecord={classCommentRecord}
              infoList={classCommentInfoList}
            />
          </TabPane>
          <TabPane tab="教练评语" key="3">
            {classListItemView()}
          </TabPane>
          <TabPane tab="完课信息" key="5">
            <CourseInfoView
              completeClassInfo={completeClassInfo}
              completeClassCommentInfo={completeClassCommentInfo}
              isDetailModalVisible={isDetailModalVisible}
            />
          </TabPane>
        </Tabs>
      </Modal>
    );
  };

  // 处理视频播放和事件记录的useEffect钩子
  useEffect(() => {
    if (state.videoPlayVisible && xgConfig.url && currentRoomid) {
      classEventRecord({
        requestData: {
          roomId: currentRoomid,
        },
        page: {
          currentPage: 1,
          pageSize: 1000,
        },
      }).then(({ code, data }) => {
        if (code === '00000') {
          setrecord(data || []);
        }
      });
    }
  }, [state.videoPlayVisible, xgConfig.url, currentRoomid]);

  useEffect(() => {
    if (xgPlayer && xgConfig.url) {
      xgPlayer.on('play', () => {
        setBeginPlay(true);
      });
    }
  }, [xgPlayer, xgConfig.url]);

  // 渲染视频播放模态框
  const renderVideoModal = () => {
    return (
      <Modal
        title="视频预览"
        visible={state.videoPlayVisible}
        onCancel={hideVideoPlay}
        width={800}
        destroyOnClose
        footer={[
          <Button
            onClick={() => {
              hideVideoPlay();
            }}
            key="1"
            type="primary"
          >
            关闭
          </Button>,
        ]}
      >
        {xgConfig.url && (
          <Xgplayer
            config={xgConfig}
            playerInit={(player) => {
              setXgPlayer(player);
            }}
          />
        )}

        <ProTable
          columns={columnsMark}
          request={async (params) => {
            const { data, page, code } = await classEventRecord({
              requestData: { ...params, roomId: currentRoomid },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page.count,
            };
          }}
          rowKey={'eventTime'}
          search={false}
          toolBarRender={false}
          options={false}
          size="small"
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
          scroll={{ y: 400 }}
        />
      </Modal>
    );
  };

  return (
    <div>
      <ProTable
        columns={columns}
        actionRef={actionRef}
        scroll={{ x: 'max-content' }}
        request={async (params) => {
          if (!tenantId) {
            return {
              data: [],
              success: true,
              total: 0,
            };
          }
          const { data, page, code } = await getUserClass({
            requestData: { tenantId },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data || [],
            success: true,
            total: page?.count || 0,
          };
        }}
        rowKey={(record) => record.roomId}
        search={false}
        toolBarRender={false}
        options={false}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`,
        }}
      />
      {detailModal()}
      {cancelReasonModal()}
      {/* 巡课弹窗 */}
      <Modal
        title={'巡课'}
        width={1000}
        visible={isPatrolModalVisible}
        onCancel={handlePatrolModalCancel}
        footer={[]}
      >
        <Row justify="center" align="middle" gutter={[16, 20]}>
          {inputQRUrl && (
            <Col span={24} justify="center" align="middle">
              <QRCode id={'QRC'} value={inputQRUrl} size={200} />
            </Col>
          )}
          <Col span={24} justify="center" align="middle">
            <a>{!inputQRUrl ? '暂无巡课二维码' : '微信扫码进行巡课'}</a>
          </Col>

          <Col span={24} justify="center" align="middle">
            <Input.Group compact>
              <Input
                className={styles.wCalc200}
                defaultValue={inputH5Url}
                onChange={qrCodeInputChange}
              />
              <CopyToClipboard
                text={inputH5Url}
                onCopy={() => Message.success('复制链接成功', 5)}
              >
                <Button type="primary">复制链接</Button>
              </CopyToClipboard>
            </Input.Group>
          </Col>

          {inputLiveUrl ? (
            <Col span={24} justify="center" align="middle">
              <Button
                type="primary"
                onClick={() => playLive(inputLiveUrl)}
                icon={<PlayCircleOutlined />}
                size="large"
              >
                查看直播
              </Button>
            </Col>
          ) : (
            ''
          )}
        </Row>
      </Modal>
      {/* 直播播放弹窗 */}
      <ModalVideo
        visible={liveVideoPlayVisible}
        src={liveVideoPlaySrc}
        onCancel={() => {
          setLiveVideoPlayVisible(false);
        }}
      />
      {/* 回看视频播放模态框 */}
      {renderVideoModal()}
    </div>
  );
};

export default Curriculum;
